import React from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'

/**
 * Generic element tag, used to properly map css module without the need for custom element
 * @param {*} props
 */
const Element = props => {
  const { tag: Tag = 'div', theme, classes, ...attributes } = props
  const cn = Array.isArray(classes) ? classNames(theme, ...classes) : classNames(theme, classes)

  return <Tag className={cn} {...attributes} />
}

Element.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
}

export default Element



// WEBPACK FOOTER //
// ./ui/Element/Element.js